const PLACEHOLDER_NAMES = new Set(["ecotour user", "ecotour guest", "google user", "guest", "user"]);

export const normalizeProfileName = (value) => String(value || "").trim().replace(/\s+/g, " ");

export const validateProfileName = (value) => {
  const name = normalizeProfileName(value);
  if (name.length < 2) return "Enter your full name (at least 2 characters).";
  if (name.length > 120) return "Keep your full name within 120 characters.";
  if (PLACEHOLDER_NAMES.has(name.toLowerCase())) return "Enter your own full name.";
  // Accept names in Odia and other scripts, including initials and common separators.
  if (!/^[\p{L}\p{M}\s.'’-]+$/u.test(name) || !/\p{L}/u.test(name)) {
    return "Enter a valid name using letters, spaces, apostrophes, periods or hyphens.";
  }
  return "";
};

export const isMeaningfulName = (value) => !validateProfileName(value);

// Missing or legacy placeholder names must never become editable field values.
export const sanitizeNamePrefill = (value) => isMeaningfulName(value) ? normalizeProfileName(value) : "";
